import { FaceRecognitionStatusEnum, LayoutEnum } from '@goldcast/api/content';
import { Clip } from '@/player-config/src/types/clip-types';
import { getLayoutAvailabilityStatusPure } from '@/player-config/src/utils/getLayoutAvailabilityStatusPure';
import { isFullVideoFaceRecEnabled, isLayoutsEnabledForPreRecordedEventsFeatureFlag } from '@/stores/clip';

export function getLayoutAvailabilityStatus(
  clipLayout: LayoutEnum,
  layoutStatus: Clip['layout_status'],
  clip: Clip,
  useNewPlayer: boolean = false
): FaceRecognitionStatusEnum | null {
  return getLayoutAvailabilityStatusPure({
    clip,
    clipLayout,
    layoutStatus,
    useNewPlayer,
    isFullFaceRecEnabled: isFullVideoFaceRecEnabled(),
    areLayoutsEnabledForPreRecordedEvents: isLayoutsEnabledForPreRecordedEventsFeatureFlag()
  });
}

export const SCREENSHARE_TOAST_MESSAGE =
  'Screenshare detected. Update track selection in scenes to show or hide the screenshare stream.';

export function hasShownScreenshareToast(clipId: string): boolean {
  try {
    return localStorage.getItem(`screenshareDetectionToastShown_${clipId}`) === 'true';
  } catch {
    return false;
  }
}

export function markScreenshareToastAsShown(clipId: string): void {
  try {
    localStorage.setItem(`screenshareDetectionToastShown_${clipId}`, 'true');
  } catch {
    // Silently handle localStorage errors
  }
}
